import { NavLink, useLocation } from "react-router-dom"
import PageLayout from "components/layout/PageLayout"
import { useTranslation } from "react-i18next"
import { useGetEmployeeQuery } from "./api/employmentApiSlice"
import EmployeeAbsences from "../../hr/absenceReport/components/EmployeeAbsences"
import HasPermission, { CanGrantCriticalRoles, CanManageAbsenceRequest, CanManageWorkContracts, CanViewCompanyLog } from "app/PermissionChecker"
import UserCardLayout from "components/layout/UserCardLayout"
import Accordion from "components/commons/Accordion"
import EmployeeActivityStats from "./components/EmployeeActivityStats"
import WorkerWorkContract from "../../hr/workContract/WorkerWorkContract"


const EmployeeDetail = () => {

    const [t, i18n] = useTranslation(["global", "absenceReport"])

    let location = useLocation()

    const {
        data: employee,
        isFetching: employeeIsFetching,
        isSuccess: employeeIsSuccess,
        isError: employeeIsError,
        error: employeeError,
        refetch: refetchEmployee,
    } = useGetEmployeeQuery(location.state.userGUID)

    const absenceReportPermission = HasPermission(CanManageAbsenceRequest)
    const workerContractPermission = HasPermission(CanManageWorkContracts)
    const currentUserCanGrantCriticalRole = HasPermission(CanGrantCriticalRoles)
    const canViewCompanyLog = HasPermission(CanViewCompanyLog)

    let content
    if (employeeIsSuccess) {

        let user = employee[0].user
        let employment = employee[0]

        content = <section className="userInfo">

            <div className="col mb-2 text-end">
                <NavLink to={{ pathname: "/dashboard/employees/edit-employment" }} state={{ userGUID: employment.user.guid }} className={`btn btn-light me-1 ${employment.role.isCritical && !currentUserCanGrantCriticalRole ? "disabled" : null}`} disabled={employment.role.isCritical && !currentUserCanGrantCriticalRole}><i className="fa-solid fa-pen"></i> {t("action.edit")}</NavLink>
            </div>

            <UserCardLayout user={user} employment={employment} />

            {
                (() => {
                    let items = []

                    if (canViewCompanyLog) {
                        items.push({
                            icon: <i className="fa-solid fa-chart-line"></i>,
                            title: t("menu.activity"),
                            body: <EmployeeActivityStats userGuid={employment.user.guid} />
                        })
                    }

                    if (absenceReportPermission) {
                        items.push({
                            icon: <i className="fa-solid fa-calendar-check"></i>,
                            title: t("absenceReport:module.short_name"),
                            body: <EmployeeAbsences userGUID={user.guid} />
                        })
                    }

                    if (workerContractPermission) {
                        items.push({
                            icon: <i className="fa-solid fa-briefcase"></i>,
                            title: t("absenceReport:menu.contract"),
                            body: <WorkerWorkContract userGUID={user.guid} />
                        })
                    }

                    return <Accordion
                        items={items}
                    />
                }
                )()
            }

        </section>

    }


    return <PageLayout
        pageTitle={employeeIsFetching ? t("entity.employee") : t("entity.employee") + " : " + employee?.[0].user.displayName ?? "undefine"}
        isError={employeeIsError}
        errorMsg={employeeError}
        isLoadingPage={employeeIsFetching}
        onPageRefresh={refetchEmployee}
        bodyContent={content}
    />



}

export default EmployeeDetail